<template>
  <div class="competitor-score-status" :data-state="state" :data-automatic="automatic">
    <span :title="statusName">{{ statusShortname }}</span>
    <el-input-number
      class=""
      type="text"
      controls-position="right"
      @change="changeScore"
      :value="value"
      size="mini"></el-input-number>
  </div>
</template>

<script>
export default {
  name: 'SportGamesCompetitorScore',
  props: {
    scoreDiscipline: Object,
    competitorId: Number,
    scoreAutomatic: Boolean,
    statusGameId: Number,
    disciplineId: Number
  },
  computed: {
    statusId () { return this.scoreDiscipline.gameStatusId },
    automatic () { return this.scoreDiscipline.automatic ? (this.scoreAutomatic ? 2 : 1) : 0 },

    status () { return this.$store.getters['Sport/GameStatus/get'](this.statusId) },
    statusName () { return this.status.name },
    statusShortname () { return this.status.shortname },

    state () { return this.status.live ? 1 : (this.status.stopped ? 2 : (this.status.ended ? 3 : 0)) },

    score () { return this.getScore(this.statusId) },
    value () { return this.score === undefined ? undefined : this.score.score },

    scores () { return this.$store.getters['Sport/ScoreDiscipline/get'](this.disciplineId).filter(item => item.automatic === 1) }
  },
  methods: {
    getScore (statusId) {
      return this.$store.getters['Sport/CompetitorScore/get'](this.competitorId, statusId, 1)
    },
    changeScore (value) {
      if (value !== undefined) {
        if (this.score) {
          this.scoreUpdate(this.score.id, value)
        } else {
          this.scoreNew(this.statusId, value)
        }
        this.automaticChangeScore(value)
      } else {
        if (this.score) {
          this.$store.dispatch('Sport/CompetitorScore/delete', this.score.id)
        }
      }
    },
    automaticChangeScore (value) {
      if (this.statusId === 100 && this.scoreAutomatic === true && value !== undefined) {
        const scoresId = this.scores.map(item => item.gameStatusId)
        if (scoresId.indexOf(this.statusGameId) > -1) {
          const scoreStatus = this.scores.find(item => item.gameStatusId === this.statusGameId)
          const scoresBefore = this.scores.filter(item => item.order < scoreStatus.order)
          let scoreCompute = 0
          if (scoresBefore.length > 0) {
            scoresBefore.forEach(element => {
              const score = this.getScore(element.gameStatusId)
              if (score) {
                scoreCompute += score.score
              }
            })
          }
          const valueAutomatic = value - scoreCompute

          const currentScore = this.$store.getters['Sport/CompetitorScore/get'](this.competitorId, this.statusGameId, 1)
          if (currentScore) {
            this.scoreUpdate(currentScore.id, valueAutomatic)
          } else {
            this.scoreNew(this.statusGameId, valueAutomatic)
          }
        }
      }
    },
    scoreUpdate (id, value) {
      this.$store.dispatch('Sport/CompetitorScore/put', { id: id, score: value })
    },
    scoreNew (statusId, value) {
      const parameters = {
        competitorId: this.competitorId,
        statusId: statusId,
        order: 1,
        score: value
      }
      this.$store.dispatch('Sport/CompetitorScore/post', parameters)
    }
  }
}
</script>

<style scoped>
  .competitor-score-status{
    display:flex;
    flex-direction:column;
    align-items:center;
    border:transparent 1px solid;
    border-radius:4px;
    padding:2px
  }
  .competitor-score-status[data-automatic="1"]{
    border-color:var(--color-disable-bg)
  }
  .competitor-score-status[data-automatic="2"]{
    border-color:var(--color-disable-bg);
    background-color:var(--color-disable-bg)
  }
  .competitor-score-status > span{
    font-size:14px
  }
  .competitor-score-status[data-state="0"] > span{
    color:var(--color-upcoming)
  }
  .competitor-score-status[data-state="1"] > span{
    color:var(--color-live)
  }
  .competitor-score-status[data-state="2"] > span{
    color:var(--color-stopped)
  }
  .competitor-score-status[data-state="3"] > span{
    color:var(--color-ended)
  }
  .competitor-score-status > div{
    max-width:60px
  }
</style>
<style>
  .competitor-score-status > div.el-input-number.is-controls-right .el-input__inner{
    padding-left:0;
    padding-right:30px
  }
</style>
